// SPDX-License-Identifier: BUSL-1.1

/**
 * Tab navigation strip for the agent-detail page.
 *
 * Extracted from `routes/agent-detail.tsx` during the P3b refactor.
 */

import type { TabId } from './types';

export function AgentDetailTabBar({
  activeTab,
  onSelect,
  showSessions,
  showJobs,
  showEvents,
  sessionCount,
  jobCount,
  eventCount,
  hasMoreEvents,
}: {
  activeTab: TabId;
  onSelect: (tab: TabId) => void;
  showSessions: boolean;
  showJobs: boolean;
  showEvents: boolean;
  sessionCount: number;
  jobCount: number;
  eventCount: number;
  hasMoreEvents: boolean;
}) {
  return (
    <div className="mb-4 flex gap-1 border-b border-neutral-800">
      {(showSessions || showJobs) && (
        <button
          onClick={() => onSelect('activity')}
          className={`px-4 py-2 text-sm ${
            activeTab === 'activity'
              ? 'border-b-2 border-blue-500 text-blue-400'
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          Activity
          <span className="ml-1 text-xs text-neutral-500">
            ({sessionCount + jobCount})
          </span>
        </button>
      )}
      {showSessions && (
        <button
          onClick={() => onSelect('sessions')}
          className={`px-4 py-2 text-sm ${
            activeTab === 'sessions'
              ? 'border-b-2 border-blue-500 text-blue-400'
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          Sessions
          <span className="ml-1 text-xs text-neutral-500">
            ({sessionCount})
          </span>
        </button>
      )}
      {showJobs && (
        <button
          onClick={() => onSelect('jobs')}
          className={`px-4 py-2 text-sm ${
            activeTab === 'jobs'
              ? 'border-b-2 border-blue-500 text-blue-400'
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          Jobs
          <span className="ml-1 text-xs text-neutral-500">
            ({jobCount})
          </span>
        </button>
      )}
      {showEvents && (
        <button
          onClick={() => onSelect('events')}
          className={`px-4 py-2 text-sm ${
            activeTab === 'events'
              ? 'border-b-2 border-blue-500 text-blue-400'
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
          title="HB-03 server-side activity events: tool calls, decisions, blockers, artifacts"
        >
          Events
          <span className="ml-1 text-xs text-neutral-500">
            ({eventCount}
            {hasMoreEvents ? '+' : ''})
          </span>
        </button>
      )}
    </div>
  );
}
